import { useEffect } from 'react';

interface SchemaOrgProps {
  type: 'WebPage' | 'Organization' | 'FAQPage';
  data: Record<string, any>;
}

export const SchemaOrg: React.FC<SchemaOrgProps> = ({ type, data }) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    
    const baseUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    let schemaData: Record<string, any> = {
      '@context': 'https://schema.org',
      '@type': type,
      ...data,
    };

    // URLの処理
    if (schemaData.url && !schemaData.url.startsWith('http')) {
      schemaData.url = `${baseUrl}${schemaData.url}`;
    }

    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [type, data]);

  return null;
};
